<template>
  <div class="login-page">
    <div class="login-card">
      <h1 class="login-title">星星家</h1>
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请输入用户名' }]"
        />
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        <div class="login-actions">
          <van-button round block type="primary" native-type="submit" :loading="loading">
            登录
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { login } from '../util/api'
import { Notify } from 'vant'

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
    }
  },
  methods: {
    onSubmit() {
      this.loading = true
      login({
        username: this.username.trim(),
        password: this.password,
      })
        .then((res) => {
          const data = res.data
          if (data.code !== 0 || !data.token) {
            Notify({ type: 'danger', message: data.message || '登录失败' })
            return
          }
          this.$store.commit('setAuth', {
            token: data.token,
            user: data.user,
          })
          this.$router.replace('/')
        })
        .catch(() => {
          Notify({ type: 'danger', message: '登录失败，请稍后重试' })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: linear-gradient(180deg, #e8f7ff 0%, #f7fbff 45%, #ffffff 100%);
}

.login-card {
  width: 100%;
  max-width: 360px;
  padding: 28px 20px 24px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 40px rgba(52, 195, 255, 0.15);
}

.login-title {
  margin: 0;
  font-size: 24px;
  text-align: center;
  color: #1f2937;
}

.login-subtitle {
  margin: 8px 0 20px;
  text-align: center;
  color: rgba(31, 41, 55, 0.65);
}

.login-actions {
  margin-top: 20px;
}
</style>
